// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface QueryState {
  value: string;
}

const initialState: QueryState = {
  value: ''
};

const QuerySlice = createSlice({
  name: 'query',
  initialState,
  reducers: {
    updateQuery: (state: QueryState, action: PayloadAction<string>) => {
      state.value = action.payload;
    }
  }
});

export const { updateQuery } = QuerySlice.actions;
export default QuerySlice.reducer;
